<div #container
     [class.collapsed]="isCollapsed"
     [class.expanded]="!isCollapsed"
     class="collapsible p-1">
    @if (!isCollapsed || content.offsetHeight > container.offsetHeight) {
        <span (click)="toggleCollapsed()"
              (keydown.enter)="toggleCollapsed()"
              [class.px-1]="isCollapsed"
              [class.fa-chevron-right]="isCollapsed"
              [class.fa-chevron-down]="!isCollapsed"
              class="df-collapse mx-2">
        </span>
    }
    <span #content>
        {{ value }}
    </span>
</div>
